import type { CreatorSiteSectionType } from './creator-site';

export const CREATOR_SITE_SECTION_VARIANTS = {
  hero: ['default', 'split', 'video'],
  about: ['default', 'card'],
  testimonials: ['default', 'compact'],
} as const satisfies Partial<Record<CreatorSiteSectionType, readonly string[]>>;

export type CreatorSiteVariantSectionType = keyof typeof CREATOR_SITE_SECTION_VARIANTS;

export function listCreatorSiteSectionVariants(type: string): readonly string[] {
  const variants = CREATOR_SITE_SECTION_VARIANTS[type as CreatorSiteVariantSectionType];
  return variants ?? ['default'];
}

export function validateCreatorSiteSectionVariant(
  type: string,
  variant: string,
): { ok: true; variant: string } | { ok: false; message: string } {
  const normalized = variant.trim().toLowerCase() || 'default';
  const allowed = listCreatorSiteSectionVariants(type);
  if (!allowed.includes(normalized)) {
    return {
      ok: false,
      message: `variant "${normalized}" is not allowed for section type "${type}"`,
    };
  }
  return { ok: true, variant: normalized };
}
